import { CancelToken } from 'api';
import { post } from 'features/api';
import { GetStocksRequestBody, RTPResponse } from './types';

export function* fetchGoodsSupplyData(requestData: GetStocksRequestBody, cancelToken?: CancelToken) {
  return yield* post<RTPResponse>('get-stocks', requestData, {
    cancelToken,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
